import * as React from 'react'
import Stack from '@mui/material/Stack'
import Divider from '@mui/material/Divider'
import { ActivitySummaryTabs } from '../../ActivitySummaryTabs'
import { ActivitySummaryTable } from '../../ActivitySummaryTable'
import { ActivitySummaryFilters } from '../../ActivitySummaryFilters'
import { ActivitySummaryTopStats } from '../../ActivitySummaryTopStats'
import { EditActivityPopover } from '@user/features/Activity/components/EditActivityPopover/EditActivityPopover'
import { EditActivityStatusPopover } from '@user/features/Activity/components/EditActivityStatusPopover/EditActivityStatusPopover'
import { useData, useHandlers } from './hooks'
import { toolbarHeight } from '@sales-center/common'

export function ActivitySummaryDialogContent() {
  const { anchorEl, editActivityId, editStatusActivityId } = useData()
  const { onClose, onSave } = useHandlers()

  return (
    <Stack mt={toolbarHeight} height="100%" minHeight={0}>
      <ActivitySummaryTopStats />
      <Divider />
      <ActivitySummaryFilters />
      <Divider />
      <ActivitySummaryTabs />
      <ActivitySummaryTable />
      <EditActivityPopover
        activityId={editActivityId}
        anchorEl={anchorEl}
        onClose={onClose}
        onSave={onSave}
      />
      <EditActivityStatusPopover
        activityId={editStatusActivityId}
        anchorEl={anchorEl}
        onClose={onClose}
        onSave={onSave}
      />
    </Stack>
  )
}
